import { bffCrmPersonMedications } from '@fireflyhealth/api'
import type { BffCrmPersonMedicationsRetrieveResponse } from '@fireflyhealth/api'

import { useQuery } from '~/shared/hooks/query'

export type PersonMedication = BffCrmPersonMedicationsRetrieveResponse['active_medications'][number]
export type PharmacyLink = BffCrmPersonMedicationsRetrieveResponse['pharmacies'][number]

/** The member's server-ordered medications and pharmacies; disabled until a `personId` exists. */
export const useGetPersonMedications = (variables: { personId: number | undefined }) => {
  const { personId } = variables
  return useQuery<BffCrmPersonMedicationsRetrieveResponse>(
    personId != null
      ? bffCrmPersonMedications.retrieveQueryKey({ person_id: personId })
      : ['retrieveBffCrmPersonMedications', {}],
    async () => (await bffCrmPersonMedications.retrieve({ person_id: Number(personId) })).data,
    { enabled: personId != null },
    { error: 'Failed to fetch medications' },
  )
}
